<template>
    <div>

        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Evaluation Metrics</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card class="custom-card">
            <el-form class="custom-form">

                <el-row :gutter="20">
                    <el-col :span="12">
                        <!-- Dataset -->
                        <el-form-item label="Dataset" class="form-item">
                            <el-select v-model="selectDatasetID" placeholder="Select dataset" class="custom-select">
                                <template slot="prefix">
                                    <i class="iconfont icon-shujuku"></i>
                                </template>
                                <el-option
                                    v-for="(dataset, index) in datasetlist"
                                    :key="index"
                                    :label="dataset.Name"
                                    :value="dataset.DatasetID">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row :gutter="20">

                    <!-- Metric Selection -->
                    <el-col :span="24" class="metric-label">
                        Metrics
                        <el-checkbox v-model="isAllSelected" @change="handleSelectAll" class="custom-checkbox">
                            Select / Deselect All
                        </el-checkbox>
                    </el-col>

                    <el-col :span="24">
                        <el-checkbox-group v-model="selectMetircList" class="checkbox-group">
                            <el-checkbox
                                v-for="(option, index) in metricList"
                                :key="index"
                                :label="option.Name"
                                :value="option.MetricID"
                                class="custom-checkbox">
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-col>

                    <!-- Precision -->
                    <el-col :span="24" class="metric-label">
                        Precision
                        <el-radio-group v-model="radio">
                            <el-radio :label="2">2 decimals</el-radio>
                            <el-radio :label="3">3 decimals</el-radio>
                            <el-radio :label="4">4 decimals</el-radio>
                        </el-radio-group>
                    </el-col>

                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12" class="submit-button">
                        <el-form-item>
                            <el-button type="primary" @click="submit" class="custom-button">
                                Query Metrics
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

            <!-- Public Leaderboard -->
            <div class="leaderboard-title">
              Public Leaderboard
              <span class="leaderboard-legend">
                Note: click a method name to view fusion examples. Click Method / Year for filtering competitors. &nbsp;&nbsp;
                <span class="metric-best">■</span>: Top1
                &nbsp;&nbsp;
                <span class="metric-second">■</span>: Top2
              </span>
            </div>

            <el-table :data="public_method_metric_List" border stripe class="custom-table">
                <el-table-column type="index" label="#" width="80"></el-table-column>
                <el-table-column
                  label="Method"
                  prop="MethodName"
                  :filters="methodFilters"
                  :filter-method="filterMethod"
                  :filtered-value="defaultMethodFilters"
                  filter-placement="bottom-end"
                  filter-multiple
                >
                      <template slot-scope="scope">
                          <span
                            class="method-link"
                            title="Click to view fusion examples"
                            @click="showExamples(scope.row)"
                          >
                            {{ scope.row.MethodName }}
                          </span>
                      </template>
                </el-table-column>
                <el-table-column label="Venue" prop="Venue"></el-table-column>
                <el-table-column
                  label="Year"
                  prop="Year"
                  :filters="yearFilters"
                  :filter-method="filterYear"
                  :filtered-value="defaultYearFilters"
                  filter-placement="bottom-end"
                >
                </el-table-column>

                <el-table-column
                    v-for="metric in selectMetircList"
                    :key="'public-' + metric"
                    :label="metric + '*'"
                    sortable
                    :prop="metric">
                    <template slot-scope="scope">
                        <span
                            v-if="scope.row[metric] !== undefined && scope.row[metric] !== null"
                            :class="getMetricCellClass(public_method_metric_List, metric, scope.row[metric])">
                            {{ formatNumber(scope.row[metric], radio) }}
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>

            <!-- Private Leaderboard -->
            <div style="margin-top: 30px; font-size: 18px; font-weight: bold;">
                Private Leaderboard
            </div>

          <el-table :data="private_method_metric_List" border stripe class="custom-table">
              <el-table-column type="index" label="#" width="80"></el-table-column>
              <el-table-column label="Method" prop="MethodName"></el-table-column>

              <!-- ✅ 新增这两列 -->
              <el-table-column label="Venue">
                <template slot-scope="scope">
                  {{ scope.row.Venue || "-" }}
                </template>
              </el-table-column>

              <el-table-column label="Year" >
                <template slot-scope="scope">
                  {{ scope.row.Year || "-" }}
                </template>
              </el-table-column>

                <el-table-column
                    v-for="metric in selectMetircList"
                    :key="'private-' + metric"
                    :label="metric + '*'"
                    sortable
                    :prop="metric">

                    <template slot-scope="scope">
                        <span
                            v-if="scope.row[metric] !== undefined && scope.row[metric] !== null"
                            :class="getMetricCellClass(private_method_metric_List, metric, scope.row[metric])">
                            {{ formatNumber(scope.row[metric], radio) }}
                        </span>
                        <span v-else>-</span>
                    </template>

                </el-table-column>
            </el-table>

        </el-card>

<el-dialog
  title="Fusion Examples"
  :visible.sync="exampleDialogVisible"
  width="600px"
>
  <div class="example-grid">
    <div
      v-for="(img, index) in exampleImages"
      :key="index"
      class="example-item"
    >
      <img
        :src="img.url"
        class="example-img"
      />
      <div class="example-name">{{ img.name }}</div>
    </div>
  </div>
</el-dialog>

    </div>

</template>


<script>
import { List } from 'echarts';


export default {
    data() {
        return {

            exampleDialogVisible: false,
            exampleImages: [],

            Authorization: "",
            datasetlist: [],// 数据集列表
            methodList: [], // 方法列表
            metricList: [], // 度量列表


            public_method_metric_List: [], // 公共榜单（管理员方法）
            private_method_metric_List: [], // 私有榜单（普通用户方法）

            // 数据集合
            selectDatasetID: '',
            selectMetircList: [], // 已选择的metric列表
            isAllSelected: false, // 是否全选metric列表
            radio: 3,

            methodFilters: [],
            yearFilters: [],
            defaultMethodFilters: [],
            defaultYearFilters: []

        };
    },

    watch: {
        selectMetircList(newVal) {
            // 监听 selectMetircList 的变化，更新全选状态  
            this.isAllSelected = newVal.length === this.metricList.length;
        },
    },

    created() {
        var user = JSON.parse(sessionStorage.getItem("user"));
        console.log(user);
        if (user) {
            this.Authorization = "Bearer " + user.access_token;
        }
        console.log(this.Authorization);

        this.initPage();
    },

    methods: {

        async showExamples(row) {
            try {
                const response = await this.$http.get(
                    `/method/examples?method_id=${row.MethodID}&dataset_id=${this.selectDatasetID}`,
                    {
                        headers: {
                            Authorization: this.Authorization
                        }
                    }
                )
                this.exampleImages = response.data.images
                this.exampleDialogVisible = true
            } catch (error) {
                console.error(error)
                this.$message.error("Failed to load examples")
            }
        },
        filterMethod(value, row) {
          return row.MethodName === value;
        },
        filterYear(value, row) {
          return row.Year === value;
        },
        getSortedMetricValues(list, metric) {
            return list
                .map(row => row[metric])
                .filter(v => v !== undefined && v !== null && !isNaN(v))
                .map(v => Number(v))
                .sort((a, b) => b - a); // 默认越大越好
        },

        getBestValue(list, metric) {
            const values = this.getSortedMetricValues(list, metric);
            return values.length > 0 ? values[0] : null;
        },

        getSecondBestValue(list, metric) {
            const values = this.getSortedMetricValues(list, metric);
            if (values.length < 2) return null;

            // 去重后取第二个，避免第一名有多个相同值时第二名仍然是同一个值
            const uniqueValues = [...new Set(values)];
            return uniqueValues.length > 1 ? uniqueValues[1] : null;
        },

        getMetricCellClass(list, metric, value) {
            if (value === undefined || value === null || isNaN(value)) {
                return "";
            }

            const numValue = Number(value);
            const bestValue = this.getBestValue(list, metric);
            const secondBestValue = this.getSecondBestValue(list, metric);

            if (bestValue !== null && numValue === bestValue) {
                return "metric-best";
            }
            if (secondBestValue !== null && numValue === secondBestValue) {
                return "metric-second";
            }
            return "";
        },
        async initPage() {
            try {
                await this.getMethodList();
                await this.getDatasetList();
                await this.getMetircList();

                if (this.datasetlist.length > 0) {
                    this.selectDatasetID = this.datasetlist[0].DatasetID;
                }

                if (this.metricList.length > 0) {
                    const defaultMetrics = ["VIF", "QABF", "SSIM", "PSNR", "FMI_DCT", "SCD", "AG", "EN","SD"];

                    this.selectMetircList = this.metricList
                      .filter(m => defaultMetrics.includes(m.Name))
                      .map(m => m.Name);

                    this.isAllSelected = this.selectMetircList.length === this.metricList.length;
                }

            if (this.selectDatasetID && this.selectMetircList.length > 0) {
                await this.submit();
            }
            } catch (error) {
                console.error("Failed to initialize page:", error);
            }
        },

        formatNumber(value, precision) {
            if (value === undefined || value === null || isNaN(value)) {
                return "-";
            }
            return Number(Number(value).toFixed(precision));
        },

        // 获取方法列表
        async getMethodList() {
            try {
                const response = await this.$http.get("/method/show_by_user", {
                    headers: {
                        "Authorization": this.Authorization,
                        "Content-Type": "application/json",
                    },
                });
                this.methodList = response.data;
                console.log(this.methodList);
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to fetch method list');
            }
        },

        // 数据集列表获取
        async getDatasetList() {
            // 调用get请求
            try {
                const response = await this.$http.get("/dataset/getall", {
                    headers: {
                        "Authorization": this.Authorization,
                        "Content-Type": "application/json"
                    }
                });

                // 使用 JSON.stringify() 查看数据内容
                console.log(JSON.stringify(response.data, null, 2));  // 格式化输出

                this.datasetlist = response.data;
                // 打印 datasetlist 的实际内容
                console.log(JSON.parse(JSON.stringify(this.datasetlist)));  // 防止响应式属性影响
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to fetch dataset list');
            }
        },


        // 获取指标列表
        async getMetircList() {

            try {
                const response = await this.$http.get("/metrics", {
                    headers: {
                        "Authorization": this.Authorization,
                        "Content-Type": "application/json",
                    },
                });
                console.log(response);
                this.metricList = response.data;
                console.log(this.methodList);
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to fetch metric list');
            }
        },



        async submit() {

            this.public_method_metric_List = [];
            this.private_method_metric_List = [];


            if (!this.selectDatasetID) {
                this.$message.warning("Please select a dataset first");
                return;
            }

            const queryParams = new URLSearchParams({
                DatasetID: this.selectDatasetID
            });

            try {
                const response = await this.$http.get(`/records/dataset_method_metrics?${queryParams.toString()}`, {
                    headers: {
                        "Authorization": this.Authorization,
                        "Content-Type": "application/json",
                    },
                });

                const publicData = response.data.public_list || [];
                const privateData = response.data.private_list || [];

                this.public_method_metric_List = publicData.slice().sort((a, b) => {
                    const ay = Number(a.Year ?? 999999);
                    const by = Number(b.Year ?? 999999);
                    return ay - by;
                });

                this.private_method_metric_List = privateData;

                this.methodFilters = [
                  ...new Set(
                    this.public_method_metric_List.map(item => item.MethodName)
                  )
                ].map(name => ({
                  text: name,
                  value: name
                }));

                this.yearFilters = [
                  ...new Set(
                    this.public_method_metric_List
                      .map(item => item.Year)
                      .filter(y => y !== null && y !== undefined)
                  )
                ]
                .sort((a, b) => b - a)   // ⭐ 按年份降序（更合理）
                .map(year => ({
                  text: year,
                  value: year
                }));

                this.defaultMethodFilters = this.methodFilters.map(f => f.value);
                this.defaultYearFilters = this.yearFilters.map(f => f.value);

                console.log("public leaderboard:", this.public_method_metric_List);
                console.log("private leaderboard:", this.private_method_metric_List);

            } catch (error) {
                console.error(error);
                this.$message.error(error.response?.data?.msg || error.response?.data?.error || 'Query failed');
            }
        },

        handleSelectAll(checked) {
            // 全选或取消全选  
            if (checked) {
                this.selectMetircList = this.metricList.map(option => option.Name);
            } else {
                this.selectMetircList = [];
            }
        },

    }
};

</script>

<style scoped>
/* 可以根据需要自定义样式 */

.metric-best {
    color: #D97706;   /* 金色（第一名） */
    font-weight: 600;
}

.metric-second {
    color: #2563EB;   /* 深蓝（第二名） */
    font-weight: 600;
}

.custom-card {
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.custom-form {
    margin-bottom: 20px;
}

.form-item {
    margin-bottom: 20px;
}

.custom-select {
    width: 100%;
}

.metric-label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
}

.checkbox-group {
    margin-bottom: 20px;
}

.custom-checkbox {
    margin-right: 15px;
}

.submit-button {
    text-align: left;
}

.custom-button {
    width: 100%;
    border-radius: 4px;
}

/* ===== 表格整体 ===== */
.custom-table {
    width: 100%;
    margin-top: 20px;
    border: none !important;
    font-size: 14px;
    color: #111827; /* 更深的字体 */
}

/* ===== 去掉所有边框 ===== */
.custom-table ::v-deep .el-table__cell {
    border: none !important;
}

/* ===== 表头（第一条线） ===== */
.custom-table ::v-deep thead tr th {
    font-weight: 600;
    color: #111827;
    background: #ffffff;
    border-top: 2px solid #111827;   /* 上线 */
    border-bottom: 1px solid #d1d5db; /* 中线 */
}

/* ===== 表体 ===== */
.custom-table ::v-deep tbody tr td {
    color: #1f2937;
}

/* ===== 最后一行（第三条线） ===== */
.custom-table ::v-deep tbody tr:last-child td {
    border-bottom: 2px solid #111827;
}

/* ===== hover（轻微） ===== */
.custom-table ::v-deep tbody tr:hover {
    background-color: #f9fafb;
}

/* ===== 排名高亮（你原来的） ===== */
.metric-best {
    color: #D97706;
    font-weight: 700;
}

.metric-second {
    color: #2563EB;
    font-weight: 600;
}

.custom-table ::v-deep thead th {
    letter-spacing: 0.3px;
}

.leaderboard-title {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #1f2a44;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.leaderboard-legend {
    font-size: 13px;
    color: #6b7280;
}

.leaderboard-legend span {
    font-size: 12px;
}

.metric-best {
    color: #c53f2d;
    font-weight: 700;
}

.metric-second {
    color: #2563EB;
    font-weight: 600;
}

.method-link {
    color: #2563eb;
    cursor: pointer;
    font-weight: 500;
}

.method-link:hover {
    text-decoration: underline;
}

.example-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.example-img {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
}

.example-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.example-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.example-img {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
}

.example-name {
    margin-top: 6px;
    font-size: 13px;
    color: #4b5563;
    text-align: center;
    word-break: break-all;
}

</style>